import { render, staticRenderFns } from "./favorite-button.vue?vue&type=template&id=e439cef0&"
import script from "./favorite-button.vue?vue&type=script&lang=js&"
export * from "./favorite-button.vue?vue&type=script&lang=js&"
import style0 from "./favorite-button.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e439cef0')) {
      api.createRecord('e439cef0', component.options)
    } else {
      api.reload('e439cef0', component.options)
    }
    module.hot.accept("./favorite-button.vue?vue&type=template&id=e439cef0&", function () {
      api.rerender('e439cef0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/favorite-button/favorite-button.vue"
export default component.exports